// noinspection JSUnresolvedReference

import Modal from "react-modal";
import {customAdaptativeModal, viewLogOperation} from "../../../../classes/functions";

export default function ModalLog({modalLog, closeModal, view, listLogSeparation}) {
    return (
        <Modal
            isOpen={modalLog}
            onRequestClose={closeModal}
            style={customAdaptativeModal}
            contentLabel="Log"
            ariaHideApp={false}
            keepMounted
        >
            <div className="body-modal">
                <div className="formDiv">
                    <table>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Usuário</th>
                            <th>Operação</th>
                            <th>Data</th>
                            <th>Hora</th>
                            <th>Quantidade</th>
                            <th>Produto</th>
                            <th>Armazém</th>
                            <th>Endereço</th>
                        </tr>
                        </thead>
                        <tbody>
                        {listLogSeparation && listLogSeparation.length > 0 && listLogSeparation.map((item, index) => {
                            return (<tr key={index}>
                                <td>
                                    {index + 1}
                                </td>
                                <td>{item.usuario}</td>
                                <td>{viewLogOperation(item.operacao)}</td>
                                <td>{item.data}</td>
                                <td>{item.hora}</td>
                                <td>{item.dados.quantidade}</td>
                                <td>{item.dados.produto}</td>
                                <td>{item.id_warehouse}</td>
                                <td>{item.dados.endereco}</td>
                            </tr>)
                        })}
                        {listLogSeparation.length === 0 && <tr>
                            <td colSpan={8}><label className='required'>Nenhum registro encontrado!</label></td>
                        </tr>}
                        </tbody>
                    </table>
                </div>
                <div className="formDiv">
                    <button type="button" className="buttonCancel" onClick={closeModal}>Fechar
                    </button>
                </div>
            </div>
        </Modal>
    )
}